angular
    .module('AutoPrequal')
    .controller('birthdayMonthCtrl', birthdayMonthCtrl);

birthdayMonthCtrl.$inject = ['$scope', '$rootScope', 'DataFactory', 'ScrollFactory'];

function birthdayMonthCtrl($scope, $rootScope, DataFactory, ScrollFactory) {

    $rootScope.progressCurrent = 4;
    $rootScope.progressMobCurrent = 4;

    $scope.localContent = DataFactory.appData.content['birthday'];
    $scope.content = DataFactory.appData.content;
    $scope.data = DataFactory.appData.applicant;

    if (DataFactory.appData.applicant.apBirthDateMM) {
        $scope.selectedMonth = DataFactory.appData.applicant.apBirthDateMM;
    }
    else {
        $scope.selectedMonth = "";
    }
    DataFactory.appData.applicant.apBirthDateMM = $scope.selectedMonth;
    $rootScope.continueDisabled = $scope.selectedMonth === "" ? true : false;
    $scope.$watch(function () {
        return DataFactory.appData.applicant.apBirthDateMM
    }, function (newValue, oldValue) {
        if (newValue) {
            $scope.selectedMonth = newValue;
        }
    })
    $rootScope.$watch('currentStep', function (newVal) {
        if (newVal && newVal === "birthdayMonth" && $scope.selectedMonth) {
            $rootScope.continueDisabled = false;
        }
    })

    $scope.months = DataFactory.appData.content["month_list"];
    $scope.monthsFull = DataFactory.appData.content["month_list_full"];
    $scope.monthsArray = [];
    Object.keys($scope.months).map(function (key) {
        var value = $scope.months[key];
        $scope.monthsArray.push({ key: key, value: value });
    });

    $scope.nextStep = function (month) {
        DataFactory.appData.applicant.appState.birthdayMonth = true;
        if (month) {
			$scope.data.apBirthDateMM = month;
			DataFactory.setData($scope.data);
        }
        ScrollFactory.showStep("birthdayDay");
        ScrollFactory.goToStep("birthdayDay");
    }

    $rootScope.birthdayMonthNextStep = function () {
		if ($scope.selectedMonth) {
			$scope.data.apBirthDateMM = $scope.selectedMonth;
			DataFactory.setData($scope.data);
        }
        ScrollFactory.showStep("birthdayDay");
        ScrollFactory.goToStep("birthdayDay");
        return true;
    }

    $scope.prevStep = function () {
        ScrollFactory.showStep("applicantAddress");
        ScrollFactory.goToStep("applicantAddress");
    }

}
